import React, { createContext, useState } from 'react';

export const StateContext = createContext();

export const StateProvider = ({ children }) => {
  const [targetCity, setTargetCity] = useState(null);

  return (
    <StateContext.Provider value={{ targetCity, setTargetCity }}>
      {children}
    </StateContext.Provider>
  );
};
